import React from 'react';
import { Row, Col } from 'antd';
import { connect } from 'react-redux';

import { FixedWidth } from '../../../../CommonComponents/commonStyles';
import SummaryMobile from './SummaryMobile';
import SummaryWeb from './SummaryWeb';
import PropTypes from 'prop-types';

function DashboardSummary(props) {
  const { accData, grantsCountIsLoading, grantsCount, handleLinkAnalytics } = props;
  return (
    <FixedWidth>
      <Row >
        <Col className="mb-50" xs={{ span: '0' }} sm={{ span: '0' }} lg={{ span: '24' }}>
          <SummaryWeb
            isLoading={grantsCountIsLoading}
            accData={accData}
            grantsCount={grantsCount}
            handleLinkAnalytics={handleLinkAnalytics}
          />
        </Col>
        <Col xs={{ span: '24' }} sm={{ span: '24' }} lg={{ span: '0' }}>
          <SummaryMobile
            isLoading={grantsCountIsLoading}
            accData={accData}
            grantsCount={grantsCount}
            handleLinkAnalytics={handleLinkAnalytics}
          />
        </Col>
      </Row>
    </FixedWidth>
  );
}

const mapStateToProps = state => ({
  grantsCount: state.getIn(['grantsDashboard', 'grantsCount', 'data']),
  grantsCountIsLoading: state.getIn([
    'grantsDashboard',
    'grantsCount',
    'isLoading'
  ])
});

export default connect(
  mapStateToProps,
  null
)(DashboardSummary);

DashboardSummary.propTypes = {
  grantsCountIsLoading: PropTypes.bool,
  handleLinkAnalytics: PropTypes.func,
  accData: PropTypes.shape({
    accountId: PropTypes.string,
    accountName: PropTypes.string,
    availableBalance: PropTypes.number,
    beginBalance: PropTypes.number,
    currentBalance: PropTypes.number,
    dateChanged: PropTypes.number,
    endBalance: PropTypes.number,
    grantsAndContribution: PropTypes.number,
    grantsYTD: PropTypes.number,
    marketMovement: PropTypes.number,
    roleAccess: PropTypes.string,
    ytdPercentage: PropTypes.number,
    ytdPercentageIncrease: PropTypes.bool,
  }),
  grantsCount: PropTypes.shape({
    activeSchedules: PropTypes.number,
    availableBalance: PropTypes.number,
    currentBalance: PropTypes.number,
    grantAgreement: PropTypes.number,
    grantIssuedYTD: PropTypes.number,
    pendingGrant: PropTypes.number,
  })
}